import React, { Component } from 'react';

import { QuestionPathItemEditorLayout } from './../index'
import { IQuestionEditorState, IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
interface IQuestionPathItemEditorComponentProps {
    question: IQuestionEditorState | IQuestionEditor
    index?: number
    dragDisabled?: boolean
    editState: boolean
    showActions?: boolean
    hideNewQuestion?: boolean
    valueQuestion?: number
    draggableType?: string
    withoutDragDropContext?: boolean
    hideNumber?: boolean
    hideEditButton?: boolean
    hideViewButton?: boolean
    hideValue?: boolean
    showDelete?: boolean
    showEdit?: boolean
    onClick?: (question?: IQuestionEditorState | IQuestionEditor )=>void
    onClickDelete?: (question: IQuestionEditorState | IQuestionEditor)=>void
    onClickView?: (question: IQuestionEditorState | IQuestionEditor)=>void
    onClickNewAnswer?: (parent?: string) => void
    onClickEdit?: ()=>void
    onReorderChilds?: (result: any)=>void
    onChangeValue?: (e: any)=>void
}

interface IQuestionPathItemEditorComponentState {}

class QuestionPathItemEditorComponent extends Component<IQuestionPathItemEditorComponentProps, IQuestionPathItemEditorComponentState> {
    render() {
        return (
            <QuestionPathItemEditorLayout
                {...this.props}
            />
        );
    }
}

export default QuestionPathItemEditorComponent;
